import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import axios from 'axios';

import en from './locales/en.json';
import fr from './locales/fr.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr }
    },
    // French-first app. Browser detection kicks in on first visit; if the
    // browser language is neither fr nor en, fall back to English (not French).
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr'],
    load: 'languageOnly', // fr-CA -> fr, en-US -> en
    detection: {
      // 1. Respect saved preference. 2. Detect browser lang on first visit.
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false
    }
  });

// ---------- Global Accept-Language header sync ----------

const applyAxiosLanguage = (lng) => {
  const base = (lng || 'fr').substring(0, 2);
  axios.defaults.headers.common['Accept-Language'] = base;
  // Reflect on <html lang> for accessibility / OG
  if (typeof document !== 'undefined' && document.documentElement) {
    document.documentElement.lang = base;
  }
};

// Set immediately for the current session
applyAxiosLanguage(i18n.language);

// Update whenever the user switches language
i18n.on('languageChanged', (lng) => {
  applyAxiosLanguage(lng);
  // Persist to backend if the user is authenticated (best-effort, silent).
  const apiBase = process.env.REACT_APP_BACKEND_URL;
  if (apiBase) {
    axios
      .put(`${apiBase}/api/user/preferences`, { language: lng.substring(0, 2) })
      .catch(() => { /* not authenticated or backend unavailable — ignore */ });
  }
});

export default i18n;
